import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight, Camera } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal, MaskLine } from "../../lib/motion.jsx";
import { getGallery } from "../../lib/api";

export default function JeugdGalerij() {
  const { t } = useLang();
  const [photos, setPhotos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { getGallery("jeugd").then(setPhotos).catch(() => {}); }, []);

  const groups = photos.reduce((acc, p) => {
    (acc[p.activity] = acc[p.activity] || []).push(p);
    return acc;
  }, {});

  return (
    <div className="jeugd-theme min-h-screen" data-testid="jeugd-galerij">
      <section className="pt-16 pb-8">
        <div className="mx-auto max-w-7xl px-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#E07A5F]/10 px-4 py-1.5 text-xs font-semibold text-[#E07A5F] mb-4">
            <Camera size={13} /> Inkad Jeugd
          </span>
          <h1 className="font-fredoka text-4xl md:text-6xl font-bold text-[#262626] leading-none"><MaskLine>{t("galerijTitle")}</MaskLine></h1>
          <p className="mt-5 max-w-2xl text-lg text-[#52525B]">{t("galerijLead")}</p>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-6 pb-16 space-y-16">
        {Object.keys(groups).length === 0 && <p className="text-[#52525B]">{t("galerijEmpty")}</p>}

        {Object.entries(groups).map(([activity, imgs]) => (
          <Reveal key={activity}>
            <section data-testid={`gallery-group-${activity}`}>
              <div className="mb-6 flex items-center gap-3">
                <span className="h-2.5 w-2.5 rounded-full bg-[#E07A5F]" />
                <h2 className="font-fredoka text-2xl md:text-3xl font-bold text-[#262626]">{activity}</h2>
                <span className="text-sm text-[#52525B]/60">· {imgs.length} foto's</span>
              </div>
              <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4">
                {imgs.map((p) => (
                  <button key={p.id} onClick={() => setActive(p)} data-testid={`gallery-photo-${p.id}`}
                    className="group relative aspect-square overflow-hidden rounded-2xl bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)]">
                    <img src={p.image} alt={activity} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
                    <span className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
                  </button>
                ))}
              </div>
            </section>
          </Reveal>
        ))}

        <Reveal>
          <Link to="/jeugd/inschrijven" className="flex items-center justify-between rounded-3xl bg-gradient-to-br from-[#E07A5F] to-[#d2664a] p-8 text-white hover:scale-[1.01] transition-transform duration-200 group">
            <span className="font-fredoka text-2xl md:text-3xl font-bold">{t("joinJeugd")}</span>
            <ArrowRight size={28} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </Reveal>
      </div>

      {active && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/80 p-4" onClick={() => setActive(null)} data-testid="gallery-lightbox">
          <button className="absolute top-5 right-5 text-white/80 hover:text-white" onClick={() => setActive(null)} data-testid="gallery-lightbox-close"><X size={30} /></button>
          <figure className="max-h-[90vh] max-w-5xl" onClick={(e) => e.stopPropagation()}>
            <img src={active.image} alt={active.activity} className="max-h-[82vh] w-auto rounded-xl object-contain" />
            <figcaption className="mt-3 text-center font-fredoka text-lg font-semibold text-white">{active.activity}</figcaption>
          </figure>
        </div>
      )}
    </div>
  );
}
